import {Box, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

const LEARN_MORE_URL =
  'https://help.benchling.com/hc/en-us/articles/47505104598541-Benchling-AI-for-Academics';

/** Matches chat input / message thread max content width. */
const CHAT_CONTENT_MAX_WIDTH_PX = 800;

const useStyles = createStyles((theme) => ({
  wrapper: {
    width: '100%',
    maxWidth: CHAT_CONTENT_MAX_WIDTH_PX,
    marginTop: theme.spacing.md,
  },
}));

/**
 * BETA banner informing academic users that Benchling AI Chat is free.
 *
 * Shown above the new-chat input when starting a chat on non-private-deploy tenants.
 */
export function AcademicFreeChatBannerIfVisible(): JSX.Element | null {
  const {classes} = useStyles();

  if (BenchlingConfig.PRIVATE_DEPLOY) {
    return null;
  }
  return (
    <Box className={classes.wrapper}>
      <InlineBanner
        bannerType={InlineBannerType.BETA}
        hideIcon={true}
        text="Benchling AI Chat is free to try for academics."
        action={{
          actionType: InlineBannerActionType.CUSTOM,
          actionText: 'Learn more.',
          actionHref: LEARN_MORE_URL,
        }}
        dataTestAttrs={{component: 'AcademicFreeChatBanner', element: 'root'}}
      />
    </Box>
  );
}
